
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskAttachmentModel } from './Entities.GormCrm.TaskAttachment';
import { TransferModel } from './Entities.GormCrm.Transfer';
import { Model, ModelProperty } from 'models/Model';


export class FileReferenceModel extends Model<FileReferenceModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'fileReference.property.id', isHidden: true },
		{ name: 'userId', type: 'guid', languageString: 'fileReference.property.userId' },
		{ name: 'container', type: 'string', languageString: 'fileReference.property.container' },
		{ name: 'filePath', type: 'string', languageString: 'fileReference.property.filePath' },
		{ name: 'fileName', type: 'string', languageString: 'fileReference.property.fileName' },
		{ name: 'created', type: 'Date', languageString: 'fileReference.property.created', isHidden: true },
		{ name: 'temporary', type: 'boolean', languageString: 'fileReference.property.temporary' },
		{ name: 'deleted', type: 'Date', languageString: 'fileReference.property.deleted', isHidden: true },
		{ name: 'taskAttachments', type: 'TaskAttachmentModel[]', languageString: 'fileReference.property.taskAttachments', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskAttachmentModel }, properties: () => { return TaskAttachmentModel.classProperties } },
		{ name: 'transfers', type: 'TransferModel[]', languageString: 'fileReference.property.transfers', isHidden: true, isArray: true, isObject: true, new: () => { return new TransferModel }, properties: () => { return TransferModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public userId?: string;
	public container: string;
	public filePath: string;
	public fileName: string;
	public created?: Date;
	public temporary: boolean;
	public deleted?: Date;
	public taskAttachments: TaskAttachmentModel[];
	public transfers: TransferModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.userId = undefined;
		this.container = '';
		this.filePath = '';
		this.fileName = '';
		this.created = undefined;
		this.temporary = false;
		this.deleted = undefined;
		this.taskAttachments = [];
		this.transfers = [];
		
	}
	getProperties(){
		return FileReferenceModel.classProperties;
	}
}

